import axios from "axios";
import { getBaseURL } from "data/endpoints";
import { getHeaders } from "data/headers";

import {
  NewSurveyQuestionsResponse,
  ProgressBarStatus,
  SubmitProfilerRequest,
  SurveyQuestionsRequest,
} from "./interface";

export const getSurveyQuestionsApi = (payload: SurveyQuestionsRequest) => {
  const url = `/users/${payload.userId}/questions?categoryId=${payload.categoryId}`;
  return axios.get<NewSurveyQuestionsResponse>(getBaseURL() + url, {
    headers: getHeaders(),
  });
};

export const submitSurveyProfilerApi = (payload: SubmitProfilerRequest) => {
  // Build request body: use responseText when provided, otherwise answerIds
  const requestBody: any = {
    questionId: payload.questionId,
  };

  if (payload.responseText !== undefined) {
    requestBody.responseText = payload.responseText;
  } else {
    requestBody.answerIds = payload.answerIds;
  }

  return axios.post(
    `${getBaseURL()}/users/${payload.userId}/answers`,
    requestBody,
    {
      headers: getHeaders(),
    },
  );
};

export const getSurveyProgessBarApi = (payload: ProgressBarStatus) => {
  return axios.get(
    `${getBaseURL()}/users/${payload.userId}/answers/progress?userId=${payload.userId}`,
    {
      headers: getHeaders(),
    },
  );
};
